import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home",  webpackPreload: true */ '../components/HelloWorld.vue')

  },
  {
    path: '/mentions-legales',
    name: 'Legals',
    component: () => import(/* webpackChunkName: "legal" */ '../components/legal.vue')

  },
  {
    path: '/mon-profil',
    name: 'Profile',
    component: () => import(/* webpackChunkName: "profile" */ '../components/users/profile.vue')

  },
  {
    path: '/offices-de-tourisme',
    name: 'TouristOffices',
    component: () => import(/* webpackChunkName: "offices" */ '../components/offices/list.vue')

  },
  {
    path: '/offices-de-tourisme/:slug',
    name: 'TouristOfficesDetail',
    props: true,
    component: () => import(/* webpackChunkName: "offices" */ '../components/offices/detail.vue')

  },
  {
    name: 'Points',
    path: '/points',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "wrappert" */ '../components/points/wrapper.vue')
  },
  {
    path: '/parametres',
    name: 'Settings',
    component: () => import(/* webpackChunkName: "offices" */ '../components/settings/settings.vue')

  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    name: 'PointsOffice',
    path: '/offices-de-tourisme/:slug/points-touristiques',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "wrappert" */ '../components/points/wrapper.vue')
  },
  {
    path: '/classement',
    name: 'Rankings',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "wrappert" */ '../components/rankings.vue')
  },
  {
    path: '/mes-validations',
    name: 'Validations',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "users" */ '../components/users/validations.vue')
  },
  {
    path: '/inscription',
    name: 'Signup',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signup" */ '../components/users/signup.vue'),
    props:(route) => ({action: 'signup', redirect: route.params.redirect}),
    beforeEnter: (to, from, next) => {
      if (store.getters.dialog) {
        store.dispatch('closeDialog', {cleanHash: false});
      }
      next();
    }

  },
  {
    path: '/connexion',
    name: 'Signin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "signup" */ '../components/users/signup.vue'),
    props:(route) => ({action: 'signin', redirect: route.params.redirect}),
    beforeEnter: (to, from, next) => {


      if (store.getters.dialog) {
        store.dispatch('closeDialog', {cleanHash: false});
      }
      next();
    }
  },
  {
    path: '/points/:slug',
    name: 'DetailsPoint',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "detailPoint" */ '../components/points/detail.vue')
  },
  {
    path: '/print/pdf-qrcode/:value',
    name: 'PrintPdfQrcode',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "printqrcode" */ '../components/pdf/print_qrcode.vue')
  },
  {
    path: '/gestion',
    component: () => import(/* webpackChunkName: "detailPoint" */ '../components/gestion'),
    children: [
      {
          // `UserProfile` va être rendu à l'intérieur du `<router-view>` de `User`
          // quand `/utilisateur/:id/profil` concorde
          path: 'points',
            name: 'AdminPointList',
          component: () => import(/* webpackChunkName: "gestion" */ '../components/gestion/points/list.vue')
        },
        {
            // `UserProfile` va être rendu à l'intérieur du `<router-view>` de `User`
            // quand `/utilisateur/:id/profil` concorde
            path: 'points/add',
            name: 'AdminPointAdd',
            component: () => import(/* webpackChunkName: "gestion" */ '../components/gestion/points/add.vue')
          }
    ],
    beforeRouteEnter: (to, from, next) => {


      if (store.getters.roles.includes('admin')) {
        next();
      } else {
        next(false);
      }

    }

  }
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
